import { AxiosInstance } from 'axios';

import { purchasesEndpoints } from '../../utils/constants/endpoints';
import { axios } from '../axiosInstance';

import { AddNewPurchaseBody, GetAllPurchasesResponse } from './PurchasesApi.schema';

class PurchasesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  addNewPurchase = async (input: AddNewPurchaseBody): Promise<AddNewPurchaseBody> =>
    this.#requestInstance.post(purchasesEndpoints.purchases, input);

  getAllPurchases = async (orderId: number): Promise<GetAllPurchasesResponse> =>
    this.#requestInstance.get(purchasesEndpoints.purchasesId(orderId));
}

export const purchasesApi = new PurchasesApi(axios);
